import { render, staticRenderFns } from "./BenefitsFixedModal.vue?vue&type=template&id=0bd532cb&scoped=true&"
import script from "./BenefitsFixedModal.vue?vue&type=script&lang=ts&"
export * from "./BenefitsFixedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd532cb",
  null
  
)

export default component.exports